import { Button, ContainedModal } from "@landtechnologies/components";
import { useCookies } from "react-cookie";
import { endOfToday, isWithinInterval, subDays } from "date-fns";
import { User } from "src/js/stores/user/store";
import { ENVIRONMENT } from "src/js/util/environment";
import { Intercom } from "util/intercom";

export const COOKIE_NAME = "landinsight-trial-ending-dismissed";

interface TrialEndingModalProps {
  closeModal: () => void;
}

export const TrialEndingModal = ({ closeModal }: TrialEndingModalProps) => {
  const [_, setCookie] = useCookies([COOKIE_NAME]);

  function setTrialCookie() {
    setCookie(COOKIE_NAME, new Date().toISOString(), {
      expires: endOfToday(),
    });
  }
  function handleClose() {
    setTrialCookie();
    closeModal();
  }

  function handleUpgrade() {
    setTrialCookie();
    window.location.href = `${ENVIRONMENT.ACCOUNTS_SERVICE_PRIVATE_API_URL}/customer-portal?flow=upgrade`;
  }

  function handleContactSupport() {
    Intercom("show");
    setTrialCookie();
    closeModal();
  }

  return (
    <div className="atlas-min-w-[660px]">
      <ContainedModal
        title="Upgrade for continued access"
        contentClasses="atlas-w-auto"
        footer={
          <>
            <Button.Secondary className="atlas-mx-1" onClick={handleClose}>
              No thanks
            </Button.Secondary>

            <Button.Primary className="atlas-mx-1" onClick={handleUpgrade}>
              Upgrade for continued access
            </Button.Primary>

            <Button.Primary className="atlas-mx-1" onClick={handleContactSupport}>
              Contact support
            </Button.Primary>
          </>
        }
      >
        <p>
          Your trial with LandInsight ends in <b>{3}</b> days.{" "}
        </p>

        <p>
          You will need to upgrade for continued access. Both monthly and yearly contracts are
          available.
        </p>
        <div className="atlas-min-w-[800px]"></div>
      </ContainedModal>
    </div>
  );
};

export function showTrialEndingModal(user: User) {
  const cookies = document.cookie;
  const trialCookie = cookies
    .split("; ")
    .map((cookie: string) => {
      const [name, value] = cookie.split("=");
      return { name, value };
    })
    .find((cookie: { name: string }) => cookie.name === COOKIE_NAME);
  return last3DaysOfTrial(user) && !trialCookie;
}

export function last3DaysOfTrial(user: User): boolean {
  if (
    !user.self_service_trial_state.active ||
    user.self_service_trial_state.automatic_payment ||
    !user.self_service_trial_state.end_date
  ) {
    return false;
  }
  const trialEndDate = user.self_service_trial_state.end_date;
  const today = new Date();

  const withinLast3Days = isWithinInterval(today, {
    start: subDays(new Date(trialEndDate), 3),
    end: new Date(trialEndDate),
  });
  console.log(withinLast3Days);
  return withinLast3Days;
}
